<template>
  <div class="app">
    <div class="app-layout">
      <div class="parent-container">
        <div class="child-container">
          <div class="headerContainer">
            <AppHeader />
          </div>
          <div class="ContentContainer">
            <div class="content-wrapper">
              <router-view />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "@/components/Layout/app-header.vue";

export default {
  name: 'App',
  components: {
    AppHeader,
  },
};
</script>

<style>
.app-layout {
  background-color: whitesmoke;
  font-family: 'Inter', sans-serif;
}

.parent-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* The child container takes the full height minus header and footer */
.child-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  justify-content: flex-start;
  align-items: center;
}

/* Make sure header stays at the top */
.headerContainer {
  width: 100%;
  z-index: 100;
}

.ContentContainer {
  flex-grow: 1;
  overflow-y: auto;
  padding: 1rem;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.content-wrapper {
  width: 80%;
  box-sizing: border-box;
}

@media (min-height: 600px) {
  .app-layout {
    height: calc(100vh - 20px);
  }
}
</style>
